// ExportDetail.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import DetailPageCustum from '../../common/DetailsPage/DetailPageCustum';
import { READ_EXPORT_SHIPMENT } from '../../../services/apiRoutes';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import CustomLoader from '../../common/CustomLoader';

const ExportDetail = () => {
    const { exportShipmentId } = useParams();
    const [shipmentDetails, setShipmentDetails] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const authToken = sessionStorage.getItem('accessToken');

        axios.get(READ_EXPORT_SHIPMENT(exportShipmentId), {
            headers: {
                Authorization: `Bearer ${authToken}`,
            }
        })
            .then(response => {
                setShipmentDetails(response.data.shipment);
            })
            .catch(error => {
                console.error('Error fetching shipment details:', error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [exportShipmentId]);

    if (!shipmentDetails) {
        return <p> <CustomLoader open={loading} />
        </p>;
    }

    const formatPort = (port, country) => [port, country].filter(Boolean).join(", ");

    const tableData = [
        { label: 'Company Name', value: shipmentDetails.customer?.clientCompanyName || '' },
        { label: 'mobile', value: shipmentDetails.customer?.mobile || '' },
        { label: 'Shipment ID', value: shipmentDetails.shipmentId || '' },
        { label: 'Shipment Type', value: shipmentDetails.shipmentType?.shipmentTypeName || '' },
        { label: 'CIF/FOB Name', value: shipmentDetails.cifFob?.cifFobName || '' },
        { label: 'No. of Containers', value: shipmentDetails.noOfContainers || '' },
        { label: 'currency', value: shipmentDetails.currency?.currency || '' },
        { label: 'payment Method', value: shipmentDetails.paymentMethod?.paymentMethodName || '' },
        {
            label: 'Port Of Loading',
            value: formatPort(
                shipmentDetails?.loading?.portName,
                shipmentDetails?.loading?.country?.name
            )
        },
        {
            label: 'Port Of Destination',
            value: formatPort(
                shipmentDetails?.destination?.portName,
                shipmentDetails?.destination?.country?.name
            )
        },

    ];

    return <DetailPageCustum Icon={RocketLaunchOutlinedIcon} title="Export Shipment Details" data={tableData} />;
};

export default ExportDetail;


